import { render, staticRenderFns } from "./AmcClassroom.vue?vue&type=template&id=02135a86&scoped=true"
import script from "./AmcClassroom.vue?vue&type=script&lang=js"
export * from "./AmcClassroom.vue?vue&type=script&lang=js"
import style0 from "./AmcClassroom.vue?vue&type=style&index=0&id=02135a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02135a86",
  null
  
)

export default component.exports